import { CLIP_COMMENT_CREATE } from "MVVM/GraphQL/clipComments";
import { CommentForm } from "../../Common/CommentForm";

interface IClipCommentFormProps {
  clipId: string;
}

const ClipCommentForm = ({ clipId }: IClipCommentFormProps) => (
  <CommentForm
    mutation={CLIP_COMMENT_CREATE}
    buildVariables={(text, gifUrl) => ({ clipId, text, gifUrl })}
    getCacheTarget={(commentCreate) => ({
      __typename: "Clip",
      id: commentCreate?.comment?.clip?.id || clipId,
    })}
  />
);

export { ClipCommentForm };
